import {useSelector, useStore} from "@/components/resume/redux/hooks";
import React, {useCallback, useEffect, useImperativeHandle, useMemo} from "react";
import useConfigRender from "@/components/resume/hooks/useConfigRender";
import withComponent from "@/hoc/withComponent";
import useDispatch from "@/components/resume/redux/hooks/useDispatch";
import templateSlice from "@/components/resume/redux/services/templateSlice";
import resumeDataSlice from "@/components/resume/redux/services/resumeDataSlice";
import useDataChange from "@/components/resume/hooks/useDataChange";
import resumeSlice from "@/components/resume/redux/services/resumeSlice";
import config from "@/const";
import './index.scss'
import useForceUpdate from "@/hooks/useForceUpdate";
import Pagination from "@/components/resume/Pagination/index";
import useVersion from "./hooks/useVersion"
import withStore from "./hoc/withStore";
import useResumeInstance from "@/components/resume/hooks/useResumeInstance";
import withResumeInstance from "@/components/resume/hoc/withResumeInstance";
import usAiDecision from "@/components/resume/hooks/usAiDecision";
import styled from "styled-components"
import axios from "axios";
import { Module } from "@/common/module/module";

const ContainerStyled = styled.div`
  * {
    box-sizing: border-box;
  }

  span {
    line-height: normal;
  }

  p {
    line-height: normal;
  }

  ul {
    padding: 0;
    list-style-type: none;
  }
`


const Component = withComponent(withStore(withResumeInstance((props) => {
    const {
        baseWidth = config.resume.width,
        baseHeight = config.resume.height,
        width,
        template: template$1,
        data: $data,
        resume: $resume,
        openEdit,
        resumeRef,
        isTest,
        isDown
    } = props;
    const {onInit} = props;
    const {onChange} = props;
    const instance = useResumeInstance();
    const template = useSelector(state => state.template);
    const resume = useSelector(state => state.resume);
    const resumeData = useSelector(state => state.resumeData);
    const openAutoPagination = useSelector((state) => state.pagination.openAutoPagination);
    const openAutoOnePage = useSelector((state) => state.pagination.openAutoOnePage);
    const onePageLevel = useSelector((state) => state.pagination.onePageLevel);

    const configRender = useConfigRender();
    const [, update] = useForceUpdate();
    const store = useStore();
    const dispatch = useDispatch();
    const getScale = (width) => {
        return (width || 0) / baseWidth;
    };
    const rootRefHandler = useCallback((container) => {
        if (container) {
            instance.rootContainer = container;
        }
    }, []);
    const zoomRefHandler = useCallback((container) => {
        if (container) {
            instance.zoomContainer = container;
        }
    }, [])
    const contentRefHandler = useCallback((container) => {
        if (container) {
            instance.contentContainer = container;
        }
    }, [])
    let scale = instance.scale;

    const initData = async () => {
        if (template$1) {
            store.dispatch(templateSlice.actions.set(template$1));
        }
        if ($data) {
            store.dispatch(resumeDataSlice.actions.set($data));
        }
        if ($resume) {
            store.dispatch(resumeSlice.actions.set($resume));
        }
        const {resume, resumeData, template, pagination} = store.getState();
        instance.changeTheme(resume.themeIndex)
        if (pagination && pagination.onePageLevel) {
            instance.setPaginationOnePageLevel(pagination.onePageLevel)
        }
        const {linkConfig} = template || {};
        if (linkConfig) {
            const linkPromiseList = linkConfig.map((item) => {
                const link = document.createElement("link");
                const src = "https://web.static.jianzeppt.com/resume-css/" + item.href;
                if (item.href.indexOf("c1e4d770.css") === -1 && item.href.indexOf("2ace02b3.css") === -1 && item.href.indexOf("cbc1b7bf.css") === -1) {
                    link.setAttribute("href", src);
                    link.setAttribute("rel", item.rel);
                    document.head.append(link);
                }
                instance.linkContainers.push(link);
                return axios.get(src)
            });
            await Promise.all(linkPromiseList).catch(() => void 0)
        }
        const avatarSrc = resumeData[Module.AVATAR]?.data?.src
        if (avatarSrc) {
            try {
                await axios.get(avatarSrc)
            } catch (error) {
                
            }
        }
        if(!instance.version.currentVersion){
            instance.versionLog();
        }
        instance.isInit = true;
        update()
    };
    const onInitHandler = async () => {
        const {pagination} = store.getState();
        await new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, 200)
        })
        if (pagination.openAutoPagination) {
            await instance.pagination();
        }
        instance.updateContentHeight();
        instance.visible = true;
        update()
        onInit?.()
    }
    const onScroll = () => {
        instance.zoomContainer.scrollTop = 0;
    };
    const cCallback = async () => {
        // return
        try {
            if (!instance.isInit) return
            const {pagination} = store.getState()
            if (pagination.openAutoPagination) {
                await instance.pagination();
            }
            instance.updateContentHeight();
        } catch (e) {
            console.error(e)
        }
    }
    useImperativeHandle(resumeRef, () => (instance));

    useEffect(() => {
        if (instance.isInit && resume && width) {
            onInitHandler()
        }
    }, [instance.isInit, width, resume]);
    useEffect(() => {
        if(instance.isInit){
            instance.changeTheme(resume.themeIndex)
        }
    }, [resume.themeIndex]);
    
    useEffect(() => {
        const fontSize = resume.fontSize
        document.querySelector('.wbdCv-baseStyle')?.setAttribute('data_font_size', fontSize)
        document.querySelector('.resume-content-all')?.setAttribute('data_font_size', fontSize)


        const pageMargin = resume.pageMargin
        document.querySelector('.wbdCv-baseStyle')?.setAttribute('data-modal_pagemargin', pageMargin)
        document.querySelector('.resume-content-all')?.setAttribute('data-modal_pagemargin', pageMargin)

        const moduleMargin = resume.moduleMargin
        document.querySelector('.wbdCv-baseStyle')?.setAttribute('data-modal_margin', moduleMargin)
        document.querySelector('.resume-content-all')?.setAttribute('data-modal_margin', moduleMargin)

        console.log('abc', 
            fontSize,
            pageMargin,
            moduleMargin,
        )
        if(resume.fontFamily){
            document.querySelector('.wbdCv-baseStyle')?.setAttribute('data_font_name', resume.fontFamily)
            document.querySelector('.resume-content-all')?.setAttribute('data_font_name', resume.fontFamily)
        }
    }, [resume.fontSize, resume.fontFamily, resume.pageMargin, resume.moduleMargin])

    useEffect(() => {
        initData();

    }, []);
    useEffect(() => {
        cCallback()
    }, [resumeData, openAutoPagination, openAutoOnePage, onePageLevel]);
    useDataChange(onChange, instance);
    useVersion();
    usAiDecision();
    useEffect(() => {
        return () => {
            try {
                instance.linkContainers.forEach((link) => {
                    document.head.removeChild(link);
                })
            } catch (e) {

            }
        }
    }, [])
    if (!width || !resume) return
    return <>
        <ContainerStyled id={'resume-' + resume.resumeId} ref={rootRefHandler}
                         style={{
                             width,
                             pointerEvents: openEdit ? undefined : "none",
                             position: "relative",
                             height: instance.currenContentHeight,
                             overflow: 'hidden',
                             visibility: instance.visible ? undefined : "hidden"
                         }}>
            {
                !isDown && <Pagination pageCount={instance.pageCount}
                                       openEdit={openEdit}
                                       paginationCoverHeight={instance.paginationCoverHeight}
                                       currentPageHeight={instance.currentPageHeight}/>
            }
            <div style={{
                height: instance.currenContentHeight,
                background: "white",
                position: "absolute",
                top: 0,
                width: "100%",
                zIndex: 1,
                paddingBottom: 20
            }}/>
            <div ref={zoomRefHandler} onScroll={onScroll} style={{
                position: "relative",
                width: baseWidth,
                transform: `scale(${scale})`,
                transformOrigin: 'top left',
                zIndex: 2,
            }}>
                <div id="test1">
                    <div style={{position: "relative", zIndex: "inherit"}}>
                        <div ref={contentRefHandler}
                             className="ll-resume-content"
                             style={{position: "relative", zIndex: "inherit", height: instance.contentHeight}}>
                            {configRender(template.layoutConfig, resumeData)}
                        </div>
                    </div>
                </div>
            </div>
        </ContainerStyled>
        <div ref={(container) => instance.mergeOnePageContainer = container}
             style={{visibility: "hidden", pointerEvents: "none", position: "fixed", top: 0, right: -1000}}/>
    </>
})));

export default Component
